import { fetchApi } from '@/services/api-client';

const LESSON_NOTES_PATH = '/admin/lesson-notes';

export interface LessonNote {
  id: string;
  classId: string;
  className: string;
  subjectId: string | null;
  subjectName: string | null;
  periodId: string | null;
  periodName: string | null;
  date: string;
  body: string;
  createdAt: string;
  updatedAt: string;
}

export interface LessonNoteForLesson {
  note: LessonNote | null;
  previous: LessonNote | null;
}

export interface LessonNotesPage {
  items: LessonNote[];
  total: number;
  page: number;
  pageSize: number;
}

export interface LessonNoteOptions {
  classes: Array<{ id: string; name: string; gradeLevel: number; mine: boolean }>;
  subjects: Array<{ id: string; name: string }>;
}

export interface DiaryFilters {
  classId?: string;
  subjectId?: string;
  from?: string;
  to?: string;
  page?: number;
}

export interface LessonNoteLesson {
  classId: string;
  periodId: string;
  date: string;
}

export interface DiaryEntryBody {
  classId: string;
  subjectId: string;
  date: string;
  body: string;
}

export const lessonNotesApi = {
  forLesson: (lesson: LessonNoteLesson) =>
    fetchApi<LessonNoteForLesson>(`${LESSON_NOTES_PATH}/lesson?${new URLSearchParams({ ...lesson }).toString()}`),
  saveForLesson: (data: LessonNoteLesson & { body: string }) =>
    fetchApi<{ note: LessonNote | null }>(`${LESSON_NOTES_PATH}/lesson`, { method: 'PUT', body: JSON.stringify(data) }),
  list: (filters: DiaryFilters) => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(filters)) if (v !== undefined && v !== '') qs.set(k, String(v));
    return fetchApi<LessonNotesPage>(`${LESSON_NOTES_PATH}?${qs.toString()}`);
  },
  options: () => fetchApi<LessonNoteOptions>(`${LESSON_NOTES_PATH}/options`),
  create: (data: DiaryEntryBody) =>
    fetchApi<LessonNote>(LESSON_NOTES_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: Partial<DiaryEntryBody>) =>
    fetchApi<LessonNote>(`${LESSON_NOTES_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  remove: (id: string) => fetchApi(`${LESSON_NOTES_PATH}/${id}`, { method: 'DELETE' }),
};
